import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useAppContext } from "../../../context/AppContext";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
//components
import Panel from "../../../components/panel/panel";
import Input from "../../../components/input/Input";
//config
import { api } from "../../../utils/api";
import { Link } from "react-router-dom";
import usePermission from "../../../hooks/usePermission";

const EditNomenclature = () => {
  usePermission("155"); // Editar Nomenclaturas
  const { handleSubmit, reset, setValue, control, errors } = useForm();
  const { nomenclatures, setNomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const [loading, setLoading] = useState(false);

  const items = [
    {
      template: () => (
        <Link to={`/settings/editNomenclature`} className="p-breadcrumb-link">
          Editar Nomenclaturas
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const EditNomenclature = async (data) => {
    const { nomenclatureOne, nomenclatureTwo } = data;
    let notification = null;

    //    console.log(data);
    try {
      notification = toast.loading(
        "Por favor aguarde a edição está sendo realizada..."
      );
      setLoading(true);
      const response = await api.post(`nomenclature`, {
        block: nomenclatureOne,
        land: nomenclatureTwo,
      });
      //      console.log(response)

      //Ação final
      reset({});
    } catch (e) {
      if (notification) {
        toast.update(notification, {
          render: "Hm..Algo não ocorreu bem, verifique sua internet.",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          isLoading: false,
        });
      }
    } finally {
      if (notification) {
        toast.update(notification, {
          render: "Edição realizada com sucesso!",
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      }
      setLoading(false);
      const newNomenclatures = [
        { value: nomenclatureOne, label: nomenclatureOne },
        { value: nomenclatureTwo, label: nomenclatureTwo },
      ];
      setNomenclatures(JSON.stringify(newNomenclatures));
    }
  };

  useEffect(() => {
    if (nomenclature) {
      setValue("nomenclatureOne", nomenclature[0].value);
      setValue("nomenclatureTwo", nomenclature[1].value);
    }
  }, [nomenclature]);

  return (
    <>
      <div className="col-xl-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel mainCss="mb-4" title="Editar Nomenclatura">
        <form onSubmit={handleSubmit(EditNomenclature)}>
          <div className="d-flex row">
            <div className="col-xl-5 col-md-5 my-1 form-group">
              <Input
                name="nomenclatureOne"
                label="Nomenclatura 1"
                control={control}
                errors={errors}
              />
            </div>
            <div className="col-xl-5 col-md-5 my-1 form-group">
              <Input
                name="nomenclatureTwo"
                label="Nomenclatura 2"
                control={control}
                errors={errors}
              />
            </div>
            <div className="col-xl-1 col-md-2 my-3 form-group">
              <div className="text-center">
                <Button
                  loading={loading}
                  icon="fa fa-pencil"
                  aria-label="Search"
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
          </div>
        </form>
      </Panel>
    </>
  );
};

export default EditNomenclature;
